import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users, IndianRupee } from 'lucide-react';
import BookingModal from './BookingModal';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const TYPE_LABEL = { couple: 'Couple Room', deluxe: 'Deluxe', dormitory: 'Dormitory', tent: 'Camping Tent' };

const RoomsSection = () => {
  const [rooms, setRooms] = useState([]);
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    (async () => {
      try { const res = await axios.get(`${API_URL}/api/rooms`); setRooms((res.data || []).filter(r => !r.group || r.group === 'Butterstone River Valley')); }
      catch (e) { console.error(e); }
    })();
  }, []);

  const book = (room) => { setSelected(room); setOpen(true); };

  return (
    <section id="stay" className="section-pad bg-[#EAF0E4]" data-testid="rooms-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-12">
          <span className="overline center">Where you sleep</span>
          <h2 className="font-serif text-4xl md:text-6xl mt-4">Stay with us</h2>
          <p className="text-[#5E6E60] mt-4 max-w-2xl mx-auto">Couple rooms, spacious deluxe rooms, group dormitories and riverside camping tents — all priced per head.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rooms.map((r) => (
            <div key={r.id} className="leaf-card overflow-hidden flex flex-col" data-testid={`room-card-${r.id}`}>
              <div className="relative h-52 overflow-hidden">
                <img src={r.image_url} alt={r.name} loading="lazy" className="w-full h-full object-cover" />
                <span className="absolute top-3 left-3 bg-[#1E3226]/85 text-white text-[10px] tracking-widest uppercase px-3 py-1 rounded-full">{TYPE_LABEL[r.room_type] || r.room_type}</span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-serif text-2xl text-[#1E3226]">{r.name}</h3>
                <p className="text-xs tracking-wider uppercase text-[#6E9A5E] mt-1">{r.subtitle}</p>
                <p className="text-sm text-[#5E6E60] mt-2 flex-1">{r.description}</p>
                <div className="flex items-center gap-4 text-sm text-[#3A4A3E] mt-4">
                  <span className="flex items-center gap-1"><Users size={15} className="text-[#2F5233]" /> Sleeps {r.capacity}</span>
                  <span className="text-[#AFC2A4]">•</span>
                  <span>{r.beds}</span>
                </div>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-[#2F5233]/10">
                  <div className="flex items-center text-[#2F5233]">
                    <IndianRupee size={17} /><span className="text-2xl numeral font-medium">{(r.price_per_head || 0).toLocaleString()}</span>
                    <span className="text-xs text-[#5E6E60] ml-1">/ head</span>
                  </div>
                  <button className="btn-moss !py-2.5 !px-5" onClick={() => book(r)} data-testid={`book-room-${r.id}`}>Book</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <BookingModal isOpen={open} onClose={() => setOpen(false)} room={selected} />
    </section>
  );
};

export default RoomsSection;
